import React from 'react'
import MaintenancePage from '../../Pages/maintainnance/MaintenancePage'

const Mahe = () => {
  return (
    <>
    <MaintenancePage />
    </>
  )
}

export default Mahe